module.exports = __webpack_public_path__ + "static/media/arrow.1315e995.png";